import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DictionaryEntry } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { AddCatalog } from '../../catalog.model';

@Component({
  selector: 'app-add-catalog-dialog',
  templateUrl: './add-catalog-dialog.component.html',
  styleUrls: ['./add-catalog-dialog.component.scss']
})
export class AddCatalogDialogComponent implements OnInit {

  name = new DictionaryEntry();

  constructor(
    public dialogRef: MatDialogRef<AddCatalogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appServerAPI: AppServerAPI
  ) {

  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.appServerAPI.execute<number>('/client/erp-article/catalog/addCatalog', new AddCatalog({ name: this.name })).subscribe(response => {

      console.log('response is', response);

      this.dialogRef.close();

    }, error => {
      console.log('error is', error);
    });
  }

  confirmDisabled(): boolean {
    return this.name == null || this.name.values == null || this.name.values.length === 0 || !this.name.checkValueExistsForLanguage('de');
  }


  public onNameChanged(dictionaryEntry: DictionaryEntry) {
    this.name = dictionaryEntry;
  }

}
